export default (socket, setAlert, namespace, list, setList, event = 'getAll', params = undefined) => {
  socket.emit(`${namespace}.${event}`, params, (response) => {
    setAlert({ ...response, event: `${namespace}.${event}` });
    if (response.code < 300) {
      setList(list ? [...list, ...response.payload] : response.payload);
    }
  });
};
